var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 34.5C26.3888 34.5 34 26.8888 34 17.5C34 8.11116 26.3888 0.5 17 0.5C7.61116 0.5 0 8.11116 0 17.5C0 26.8888 7.61116 34.5 17 34.5Z",
    fill: "#485A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7869 21.7319L21.5454 21.8469V28.9539L12.794 28.8873L12.7869 21.7319V21.7319Z",
    fill: "#F9DCA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4217 29.1045C27.8331 30.8092 25.9102 32.1682 23.773 33.0965C21.6358 34.0248 19.3302 34.5026 17.0001 34.5C16.2944 34.4999 15.5894 34.4564 14.8891 34.3696C12.732 34.1027 10.6468 33.422 8.74767 32.3648C7.13072 31.465 5.67081 30.3083 4.42505 28.94L5.13146 27.2345L12.7925 23.8169C12.7925 26.3119 13.8048 27.2015 17.1773 27.2521C21.342 27.3143 21.5455 26.3686 21.5455 23.7971L28.5821 27.2527L29.4217 29.1045Z",
    fill: "#D5E1ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5471 21.8343V23.707C20.0341 26.4105 13.8448 26.4567 12.7869 21.7319L21.5471 21.8343Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.126 5.13892C28.834 5.13892 24.271 24.5409 17.126 24.5409C10.3772 24.5409 5.41804 5.13892 17.126 5.13892V5.13892Z",
    fill: "#FFE8BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1038 13.7288C8.41483 14.466 9.85075 17.9579 10.9137 17.9419C10.4728 16.5758 10.2009 15.1609 10.1038 13.7288V13.7288ZM24.2842 13.7288C25.9732 14.4654 24.5373 17.9579 23.475 17.9419C23.9155 16.5758 24.1873 15.1609 24.2842 13.7288V13.7288Z",
    fill: "#F9DCA4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8819 16.7759C23.8819 16.7759 24.4684 11.9807 22.7733 10.3104C22.0361 12.2514 18.646 12.9143 18.646 12.9143C19.3042 12.4539 19.899 11.9088 20.4148 11.293C19.5059 11.6863 16.6319 12.8653 14.0274 11.9317C14.7359 11.5046 15.4022 11.0111 16.0173 10.4578C16.0173 10.4578 13.6588 11.7353 11.374 11.4162C9.72843 12.6442 10.4607 16.4568 10.4607 16.4568C8.25235 10.6322 10.2863 3.96372 17.2695 3.92521C24.0684 3.88725 26.1656 10.443 23.8813 16.7759H23.8819Z",
    fill: "#ECBE6A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7939 23.7053C13.8643 25.3001 15.3898 26.5358 17.1721 27.2517L14.3212 30.1945L10.6951 24.6356L12.7939 23.7053Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5444 23.7053C20.4741 25.3001 18.9485 26.5358 17.1663 27.2517L20.0166 30.1945L23.6433 24.6362L21.5444 23.7053Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3567 34.4451C17.9023 34.4806 17.4431 34.4986 16.9791 34.499C16.6292 34.499 16.2817 34.4887 15.9365 34.4682L16.5037 29.6504H17.8296L18.3567 34.4451Z",
    fill: "#3DBC93"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6643 28.8091L17.1701 27.2593L18.6753 28.8091L17.1701 30.3589L15.6643 28.8091Z",
    fill: "#3DBC93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/Man.bda832bdf04b1091858a26c24c149a2d.svg";
export { ForwardRef as ReactComponent };